import type { ContactTopicOption } from "./types";

/**
 * The topics, in the order they are offered.
 *
 * Every topic is delivered to the one support mailbox: routing is a triage
 * label on the subject line and a sort key in the admin inbox, not a different
 * destination. If that changes, it changes in `contact-mail`, not here — the
 * browser must never be able to choose who receives a message.
 */
export const CONTACT_TOPICS: ContactTopicOption[] = [
  {
    value: "support",
    label: "Help with the product",
    hint: "Sign-in, connected accounts, uploads, scheduling or publishing.",
  },
  {
    value: "sales",
    label: "Plans and pricing",
    hint: "Which plan fits, invoicing, GST, or moving between plans.",
  },
  {
    value: "partnership",
    label: "Partnership or agency",
    hint: "Working together, managing client accounts, or reselling.",
  },
  {
    value: "privacy",
    label: "Privacy or data request",
    hint: "Access, correction or deletion of your personal data.",
  },
  {
    value: "grievance",
    label: "Complaint",
    hint:
      "Goes to our Grievance Officer. We acknowledge within 24 hours and resolve " +
      "within 15 days, as the IT Rules require.",
  },
  {
    value: "other",
    label: "Something else",
    hint: "Anything that does not fit the list above.",
  },
];

export const MESSAGE_MIN = 10;
export const MESSAGE_MAX = 8000;
